import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, sync } from 'vuex-pathify';
export default {
  name: 'SelectSurvey',
  props: {
    mode: {
      required: true,
      type: String,
      validator: function validator(value) {
        return ['default', 'select'].includes(value);
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultTemplate: sync('settings/defaultTemplate'),
    logo: get('theme/baseTheme@logoColor'),
    summary: get('surveys/summary'),
    surveys: function surveys() {
      // Return surveys summary array with a 'No default survey' option appended in `default` mode
      var surveys = Array.from(this.summary);

      if (this.mode === 'default') {
        surveys.push({
          id: 0,
          name: this.$t('selectSurvey.noDefault')
        });
      }

      return surveys;
    }
  },
  watch: {
    value: function value(activated) {
      if (activated) {
        if (this.mode === 'default') {
          Logger.debug('Prompt to Select Default Survey');
        } else {
          Logger.debug('Prompt to Select Survey');
        }
      }
    }
  },
  methods: {
    select: function select(templateId) {
      if (this.mode === 'default') {
        Logger.debug("Set default survey to survey id ".concat(templateId));
        this.defaultTemplate = templateId;
      } else {
        Logger.debug("Select survey id ".concat(templateId));
        this.$store.set('settings/selectedTemplate', templateId);
      }

      this.$emit('done', {
        name: 'survey',
        result: true
      });
    }
  }
};